import { createReducer, createNamespacer } from "../commons/js/utils/reducer";
import { fromPairs as _fromPairs } from 'lodash';


const namespacers = {
    resetPassword: createNamespacer("RESET_PASSWORD"),
}

const initialstate = {
    newPassword: {
        value: '',
        error: '',
        showError: '',
    },
    confirmPassword: {
        value: '',
        error: '',
        showError: '',
    },
    error: '',
    isSuccessfullyUpdated: false,
}

const resetPasswordReducer = createReducer(initialstate, {
    [namespacers.resetPassword("SET_NEW_PASSWORD")]: (state, action) => {
        return {
            ...state,
            newPassword: {
                ...state.newPassword,
                value: action.payload.value,
            },
        }
    },

    [namespacers.resetPassword("SET_CONFIRM_PASSWORD")]: (state, action) => {
        return {
            ...state,
            confirmPassword: {
                ...state.confirmPassword,
                value: action.payload.value,
            },
        }
    },

    [namespacers.resetPassword("SUCCESSFULLY_UPDATED")]: (state, action) => {
        return {
            ...state,
            isSuccessfullyUpdated: action.payload.value,
        }
    },

    [namespacers.resetPassword("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: {
                ...state.error,
                error: action.payload.value
            },
        }
    },

    [namespacers.resetPassword("CLEAR_FORM")]: (state, action) => {
        return {
            ...state
            , newPassword : {
                ...initialstate.newPassword,
            }, confirmPassword: {
                ...initialstate.confirmPassword,
            }
        }
    },
    [namespacers.resetPassword("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
})

export default resetPasswordReducer;